import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

var _dec, _class;

import { AttributeType, gl } from '@antv/l7-core';
import { decodePickingColor, encodePickingColor, rgb2arr } from '@antv/l7-utils';
import { injectable } from 'inversify';
import 'reflect-metadata';
var PickingStage = {
  NONE: 0.0,
  ENCODE: 1.0,
  HIGHLIGHT: 2.0
};
var PixelPickingPlugin = (_dec = injectable(), _dec(_class = /*#__PURE__*/function () {
  function PixelPickingPlugin() {
    _classCallCheck(this, PixelPickingPlugin);
  }

  _createClass(PixelPickingPlugin, [{
    key: "apply",
    value: function apply(layer, _ref) {
      var styleAttributeService = _ref.styleAttributeService;
      // TODO: 由于 Shader 目前无法根据是否开启拾取进行内容修改，因此即使不开启也需要生成 a_PickingColor
      layer.hooks.init.tapPromise('PixelPickingPlugin', function () {
        var _layer$getLayerConfig = layer.getLayerConfig(),
            enablePicking = _layer$getLayerConfig.enablePicking;

        styleAttributeService.registerStyleAttribute({
          name: 'pickingColor',
          type: AttributeType.Attribute,
          descriptor: {
            name: 'a_PickingColor',
            buffer: {
              data: [],
              type: gl.FLOAT
            },
            size: 3,
            // TODO: 固定 feature range 范围内的 pickingColor 都是固定的，可以生成 cache
            update: function update(feature) {
              // 只有开启拾取才需要 encode
              var id = feature.id;
              return enablePicking ? encodePickingColor(id) : [0, 0, 0];
            }
          }
        });
      }); // 必须要与 PixelPickingPass 结合使用，因此必须开启 multiPassRenderer

      layer.hooks.beforePickingEncode.tap('PixelPickingPlugin', function () {
        var _layer$getLayerConfig2 = layer.getLayerConfig(),
            enablePicking = _layer$getLayerConfig2.enablePicking;

        if (enablePicking && layer.isVisible()) {
          layer.models.forEach(function (model) {
            return model.addUniforms({
              u_PickingStage: PickingStage.ENCODE
            });
          });
        }
      });
      layer.hooks.afterPickingEncode.tap('PixelPickingPlugin', function () {
        var _layer$getLayerConfig3 = layer.getLayerConfig(),
            enablePicking = _layer$getLayerConfig3.enablePicking; // 区分选中高亮 和滑过高亮


        if (enablePicking && layer.isVisible()) {
          layer.models.forEach(function (model) {
            return model.addUniforms({
              u_PickingStage: PickingStage.HIGHLIGHT
            });
          });
        }
      });
      layer.hooks.beforeHighlight.tap('PixelPickingPlugin', function (pickedColor) {
        var _layer$getLayerConfig4 = layer.getLayerConfig(),
            highlightColor = _layer$getLayerConfig4.highlightColor,
            _layer$getLayerConfig5 = _layer$getLayerConfig4.activeMix,
            activeMix = _layer$getLayerConfig5 === void 0 ? 0 : _layer$getLayerConfig5;

        var highlightColorInArray = typeof highlightColor === 'string' ? rgb2arr(highlightColor) : highlightColor || [1, 0, 0, 1];
        layer.updateLayerConfig({
          pickedFeatureID: decodePickingColor(new Uint8Array(pickedColor))
        });
        layer.models.forEach(function (model) {
          return model.addUniforms({
            u_PickingStage: PickingStage.HIGHLIGHT,
            u_PickingColor: pickedColor,
            u_HighlightColor: highlightColorInArray.map(function (c) {
              return c * 255;
            }),
            u_activeMix: activeMix
          });
        });
      });
      layer.hooks.beforeSelect.tap('PixelPickingPlugin', function (pickedColor) {
        var _layer$getLayerConfig6 = layer.getLayerConfig(),
            selectColor = _layer$getLayerConfig6.selectColor,
            _layer$getLayerConfig7 = _layer$getLayerConfig6.selectMix,
            selectMix = _layer$getLayerConfig7 === void 0 ? 0 : _layer$getLayerConfig7;

        var highlightColorInArray = typeof selectColor === 'string' ? rgb2arr(selectColor) : selectColor || [1, 0, 0, 1];
        layer.updateLayerConfig({
          pickedFeatureID: decodePickingColor(new Uint8Array(pickedColor))
        });
        layer.models.forEach(function (model) {
          return model.addUniforms({
            u_PickingStage: PickingStage.HIGHLIGHT,
            u_PickingColor: pickedColor,
            u_HighlightColor: highlightColorInArray.map(function (c) {
              return c * 255;
            }),
            u_activeMix: selectMix,
            u_CurrentSelectedId: pickedColor,
            u_SelectColor: highlightColorInArray.map(function (c) {
              return c * 255;
            }),
            u_EnableSelect: 1
          });
        });
      });
    }
  }]);

  return PixelPickingPlugin;
}()) || _class);
export { PixelPickingPlugin as default };